import * as React from 'react'

import { TitleLineInterface } from '../../Interfaces/Draft/TitleLineInterface'
import Input from '../common/Input/Input'

export interface InvoiceTitleLinePropsInterface extends TitleLineInterface {
  onDelete?: (e: Event) => void
  onChange?: (values: TitleLineInterface) => void
  onDrop?: (which: number) => void
  automation?: string
  columns?: number
  id?: number
  readonly?: boolean
  placeholder?: string
  showProductType: boolean
}

export interface OwnStateInterface {
  dragOn: boolean
}

export class InvoiceTitleLine extends React.Component<InvoiceTitleLinePropsInterface, OwnStateInterface> {
  private values: InvoiceTitleLinePropsInterface

  constructor(props: InvoiceTitleLinePropsInterface) {
    super(props)

    this.values = {
      content: props.content,
      type: 'title',
    }

    this.state = {
      dragOn: false,
    }
  }

  public static defaultProps: InvoiceTitleLinePropsInterface = {
    content: '',
    type: 'title',
  }

  private canDrag: boolean = false
  private reactToDrag(elem: HTMLElement) {
    if (elem.getAttribute('data-type') === 'DragHandle') {
      this.canDrag = true
    }
  }

  private findDropTarget(elem: HTMLElement): HTMLElement {
    while (elem.getAttribute('data-type') !== 'DropTarget') {
      elem = elem.parentElement
    }
    return elem
  }

  public render(): JSX.Element {
    const self = this
    const actions: JSX.Element[] = []
    let colspan = this.props?.columns - 1
    if (!this.props.showProductType) {
      colspan--
    }
    if (this.props.onDelete && !this.props.readonly) {
      actions.push(
        <span
          className="delete"
          key="onDelete"
          data-automation={this.props.automation + '-delete'}
          onClick={this.props.onDelete.bind(this)}
        ></span>,
      )
    }

    return (
      <tr
        data-automation={this.props.automation}
        draggable={!this.props.readonly && this.state.dragOn}
        data-type="DropTarget"
        className="Controlled InvoiceTextLine"
        onDragOver={(e) => {
          const elem = self.findDropTarget(e.target as HTMLElement)
          elem.classList.add('Dropping')
          e.preventDefault()
        }}
        onDragLeave={(e) => {
          const elem = self.findDropTarget(e.target as HTMLElement)
          elem.classList.remove('Dropping')
          e.preventDefault()
        }}
        onDrop={(e) => {
          const elem = self.findDropTarget(e.target as HTMLElement)
          elem.classList.remove('Dropping')
          self.props.onDrop(parseInt(e.dataTransfer.getData('id'), 10))
          e.preventDefault()
        }}
        onDragStart={(e) => {
          if (!self.canDrag) {
            e.preventDefault()
          }
          e.dataTransfer.setData('id', '' + self.props.id)
        }}
        onMouseDown={(e) => {
          self.reactToDrag(e.target as HTMLElement)
        }}
      >
        <td
          data-automation={this.props.automation + '-dragHandle'}
          data-type="DragHandle"
          className="dragHandle"
          onMouseEnter={() => document.activeElement.blur()}
          onMouseOver={() => self.setState({ dragOn: true })}
          onMouseLeave={() => self.setState({ dragOn: false })}
        ></td>
        <td colSpan={colspan}>
          <Input
            className={['Title']}
            automation={this.props.automation + '-content'}
            value={this.props.content}
            onChange={(content) => {
              if (self.props.onChange) {
                self.props.onChange({ ...self.values, content })
              }
            }}
            placeHolder={this.props.placeholder}
            editable={!this.props.readonly}
            borderless={this.props.readonly}
          />
        </td>
        <td></td>
        <td>{actions}</td>
      </tr>
    )
  }
}
